import { useEffect } from "react";
import { useParams, useNavigate, Outlet, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import languageConfig from "../config/languageConfig";
import { loadAndSetLanguage } from "../store/reducers/translationReducer";
import { getPathWithoutLangPrefix } from "../config/publicRoutes";

/**
 * Wraps public routes under /:lang. Validates lang, syncs i18n and document lang/dir,
 * redirects default language to path without prefix, then renders child routes via Outlet.
 */
export function LanguageRouteWrapper() {
  const { lang } = useParams();
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    const language = languageConfig.getLanguageByUrlCode(lang);
    const pathWithoutLang = getPathWithoutLangPrefix(pathname);

    if (!lang || !language) {
      navigate(pathWithoutLang || "/", { replace: true });
      return;
    }

    const isDefault =
      language.default || language.code === languageConfig.defaultLanguage;
    if (isDefault) {
      navigate(pathWithoutLang || "/", { replace: true });
      return;
    }

    dispatch(loadAndSetLanguage(language.code));
    if (typeof document !== "undefined" && document.documentElement) {
      document.documentElement.lang = language.code;
      document.documentElement.setAttribute("dir", language.dir || "ltr");
    }
  }, [lang, pathname, dispatch, navigate]);

  const language = languageConfig.getLanguageByUrlCode(lang);
  const isDefault =
    language && (language.default || language.code === languageConfig.defaultLanguage);
  if (!lang || !language || isDefault) {
    return null;
  }

  return <Outlet />;
}

export default LanguageRouteWrapper;
